{
  "PROFILE_SETTINGS": {
    "LINK": "Настройки профиля",
    "TITLE": "Настройки профиля",
    "BTN_TEXT": "Обновить профиль",
    "DELETE_AVATAR": "Удалить аватар",
    "AVATAR_DELETE_SUCCESS": "Аватар успешно удалён",
    "AVATAR_DELETE_FAILED": "Произошла ошибка при удалении аватара, пожалуйста, попробуйте снова",
    "UPDATE_SUCCESS": "Ваши данные успешно обновлены",
    "PASSWORD_UPDATE_SUCCESS": "Ваш пароль успешно изменен",
    "AFTER_EMAIL_CHANGED": "Ваш профиль был успешно обновлен, пожалуйста, войдите снова, так как ваши учетные данные были изменены",
    "FORM": {
      "PICTURE": "Фотография профиля",
      "AVATAR": "Изображение",
      "ERROR": "Пожалуйста, исправьте ошибки",
      "REMOVE_IMAGE": "Удалить",
      "UPLOAD_IMAGE": "Загрузить изображение",
      "UPDATE_IMAGE": "Обновить изображение",
      "PROFILE_SECTION": {
        "TITLE": "Профиль",
        "NOTE": "Адрес электронной почты используется для входа."
      },
      "SEND_MESSAGE": {
        "TITLE": "Горячие клавиши для отправки сообщений",
        "NOTE": "Вы можете выбрать горячую клавишу (Enter или Cmd/Ctrl+Enter) в зависимости от ваших предпочтений при написании.",
        "UPDATE_SUCCESS": "Ваши настройки успешно обновлены",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Отправляйте сообщения, нажимая клавишу Enter вместо кнопки отправки."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Отправляйте сообщения, нажимая Cmd/Ctrl + Enter вместо кнопки отправки."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Интерфейс",
        "NOTE": "Настройте внешний вид и оформление вашей панели Chatwoot.",
        "FONT_SIZE": {
          "TITLE": "Размер шрифта",
          "NOTE": "Измените размер текста на всей панели в соответствии с вашими предпочтениями.",
          "UPDATE_SUCCESS": "Настройки шрифта успешно обновлены",
          "UPDATE_ERROR": "Произошла ошибка при обновлении настроек шрифта, пожалуйста, попробуйте ещё раз",
          "OPTIONS": {
            "SMALLER": "Меньше",
            "SMALL": "Маленький",
            "DEFAULT": "По умолчанию",
            "LARGE": "Большой",
            "LARGER": "Крупнее",
            "EXTRA_LARGE": "Очень большой"
          }
        },
        "LANGUAGE": {
          "TITLE": "Предпочитаемый язык",
          "NOTE": "Выберите язык, который вы хотите использовать.",
          "UPDATE_SUCCESS": "Ваши языковые настройки успешно обновлены",
          "UPDATE_ERROR": "Произошла ошибка при обновлении языковых настроек, пожалуйста, попробуйте снова",
          "USE_ACCOUNT_DEFAULT": "Использовать учетную запись по умолчанию"
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Личная подпись сообщения",
        "NOTE": "Создайте уникальную подпись, которая будет отображаться в конце каждого сообщения, отправляемого из любого почтового ящика. Вы также можете добавить встроенное изображение, которое поддерживается в чате, электронной почте и API-почтовых ящиках.",
        "BTN_TEXT": "Сохранить подпись сообщения",
        "API_ERROR": "Не удалось сохранить подпись! Попробуйте снова",
        "API_SUCCESS": "Подпись успешно сохранена",
        "IMAGE_UPLOAD_ERROR": "Не удалось загрузить изображение! Попробуйте снова",
        "IMAGE_UPLOAD_SUCCESS": "Изображение успешно добавлено. Пожалуйста, нажмите сохранить, чтобы сохранить подпись",
        "IMAGE_UPLOAD_SIZE_ERROR": "Размер изображения должен быть меньше {size}МБ",
        "INLINE_IMAGE_WARNING": "Pasted inline images were removed. Please use the image upload button to add images to your signature."
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Подпись сообщения",
        "ERROR": "Подпись сообщения не может быть пустой",
        "PLACEHOLDER": "Вставьте вашу личную подпись сообщения здесь."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Пароль",
        "NOTE": "Обновление пароля сбросит вашу авторизацию на всех устройствах.",
        "BTN_TEXT": "Изменить пароль"
      },
      "SECURITY_SECTION": {
        "TITLE": "Безопасность",
        "NOTE": "Управление дополнительными функциями безопасности для вашей учетной записи.",
        "MFA_BUTTON": "Управление двухфакторной аутентификацией"
      },
      "SESSIONS_SECTION": {
        "TITLE": "Active Sessions",
        "NOTE": "These are the devices currently logged in to your account.",
        "CURRENT": "Current session",
        "REVOKE": "Revoke",
        "REVOKE_SUCCESS": "Session revoked successfully",
        "REVOKE_ERROR": "Unable to revoke session. Please try again.",
        "FETCH_ERROR": "Unable to fetch sessions. Please try again.",
        "LAST_ACTIVE": "Last active",
        "UNKNOWN_DEVICE": "Unknown device"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Токен доступа",
        "NOTE": "Этот токен может быть использован, если вы настраиваете интеграцию на основе API",
        "PAID_PLAN_NOTE": "API access tokens are available on paid plans.",
        "COPY": "Копировать",
        "RESET": "Сброс",
        "CONFIRM_RESET": "Вы уверены?",
        "CONFIRM_HINT": "Нажмите еще раз для подтверждения",
        "RESET_SUCCESS": "Токен доступа успешно сгенерирован",
        "RESET_ERROR": "Не удалось сгенерировать токен доступа. Попробуйте ещё раз"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Аудио уведомления",
        "NOTE": "Включите аудио уведомления на панели управления для новых сообщений и диалогов.",
        "PLAY": "Воспроизвести звук",
        "ALERT_TYPES": {
          "NONE": "Нет",
          "MINE": "Назначено",
          "ALL": "Все",
          "ASSIGNED": "Назначенные диалоги",
          "UNASSIGNED": "Назначенные диалоги",
          "NOTME": "Открытые диалоги, назначенные другим"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "Вы не выбрали никаких опций и не будете получать аудио уведомления.",
          "ASSIGNED": "Вы будете получать уведомления о диалогах, назначенных вам.",
          "UNASSIGNED": "Вы будете получать уведомления о любых не назначенных диалогах.",
          "NOTME": "Вы будете получать уведомления о диалогах, назначенных другим.",
          "ASSIGNED+UNASSIGNED": "Вы будете получать уведомления о назначенных вам диалогах и любых неотвеченных.",
          "ASSIGNED+NOTME": "Вы будете получать уведомления о диалогах, назначенных вам и другим, но не о неназначенных.",
          "NOTME+UNASSIGNED": "Вы будете получать уведомления о неотвеченных диалогах и диалогах назначенных другим.",
          "ASSIGNED+NOTME+UNASSIGNED": "Вы будете получать уведомления о всех диалогах."
        },
        "ALERT_TYPE": {
          "TITLE": "События уведомлений для диалогов",
          "NONE": "Нет",
          "ASSIGNED": "Назначенные беседы",
          "ALL_CONVERSATIONS": "Диалоги"
        },
        "DEFAULT_TONE": {
          "TITLE": "Звук уведомления:"
        },
        "CONDITIONS": {
          "TITLE": "Условия уведомления:",
          "CONDITION_ONE": "Отправлять звуковые оповещения только в том случае, если окно браузера не активно",
          "CONDITION_TWO": "Отправлять уведомления каждые 30 сек., пока все назначенные диалоги не будут прочитаны"
        },
        "SOUND_PERMISSION_ERROR": "Автоматическое воспроизведение отключено в вашем браузере. Чтобы автоматически слышать уведомления, включите разрешение на звук в настройках браузера или взаимодействуйте со страницей.",
        "READ_MORE": "Читать далее"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Email Уведомления",
        "NOTE": "Настраивайте email уведомления здесь",
        "CONVERSATION_ASSIGNMENT": "Отправлять email уведомление, когда мне назначен диалог",
        "CONVERSATION_CREATION": "Отправлять email уведомление, когда новый диалог создан",
        "CONVERSATION_MENTION": "Отправлять email уведомление, когда вас упоминают в диалоге",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Отправлять email уведомления при создании нового сообщения в назначенном диалоге",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Отправлять уведомления по электронной почте, когда в диалоге создается новое сообщение",
        "SLA_MISSED_FIRST_RESPONSE": "Отправить уведомление по электронной почте, если диалог не соответствует SLA первого ответа",
        "SLA_MISSED_NEXT_RESPONSE": "Отправить уведомление по электронной почте, если диалог не успел получить следующий ответ SLA",
        "SLA_MISSED_RESOLUTION": "Отправить уведомление по электронной почте, если диалог не соответствует SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Настройки уведомлений",
        "TYPE_TITLE": "Тип уведомления",
        "EMAIL": "Email",
        "PUSH": "Push-уведомления",
        "TYPES": {
          "CONVERSATION_CREATED": "Новый диалог создан",
          "CONVERSATION_ASSIGNED": "Вам назначен диалог",
          "CONVERSATION_MENTION": "Вас упомянули в диалоге",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Новое сообщение создано в назначенном диалоге",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "В назначенном диалоге создано новое сообщение",
          "SLA_MISSED_FIRST_RESPONSE": "Разговор не соответствует SLA по первому ответу",
          "SLA_MISSED_NEXT_RESPONSE": "Диалог не соответствует SLA по следующему ответу",
          "SLA_MISSED_RESOLUTION": "Диалог не соответствует SLA по разрешению"
        },
        "BROWSER_PERMISSION": "Включите push-уведомления для вашего браузера, чтобы вы могли их получать"
      },
      "API": {
        "UPDATE_SUCCESS": "Настройки уведомлений сохранены",
        "UPDATE_ERROR": "При сохранении настроек произошла ошибка, пожалуйста, попробуйте еще раз"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push уведомления",
        "NOTE": "Редактируйте настройки push-уведомлений здесь",
        "CONVERSATION_ASSIGNMENT": "Отправлять push уведомление при назначении мне диалога",
        "CONVERSATION_CREATION": "Отправлять push уведомление, когда новый диалог создан",
        "CONVERSATION_MENTION": "Отправлять уведомления при упоминании в разговоре",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Отправлять push уведомления при создании нового сообщения в назначенном диалоге",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Отправлять push-уведомления при создании нового сообщения в участвующем диалоге",
        "HAS_ENABLED_PUSH": "Вы включили push уведомления для этого браузера.",
        "REQUEST_PUSH": "Включить push-уведомления",
        "SLA_MISSED_FIRST_RESPONSE": "Отправить push-уведомление, если диалог не соответствует SLA первого ответа",
        "SLA_MISSED_NEXT_RESPONSE": "Отправить push-уведомление, если диалог не успел получить следующий ответ SLA",
        "SLA_MISSED_RESOLUTION": "Отправить push-уведомление, если диалог не соответствует SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Изображение профиля"
      },
      "NAME": {
        "LABEL": "Ваше имя",
        "ERROR": "Пожалуйста, введите правильное имя",
        "PLACEHOLDER": "Пожалуйста, введите ваше ФИО"
      },
      "DISPLAY_NAME": {
        "LABEL": "Имя, которое будет отображаться",
        "ERROR": "Пожалуйста, введите правильное имя",
        "PLACEHOLDER": "Пожалуйста, введите имя, которое будет отображаться в диалогах"
      },
      "AVAILABILITY": {
        "LABEL": "Доступность",
        "STATUS": {
          "ONLINE": "В сети",
          "BUSY": "Занят",
          "OFFLINE": "Оффлайн"
        },
        "SET_AVAILABILITY_SUCCESS": "Доступность успешно установлена",
        "SET_AVAILABILITY_ERROR": "Не удалось установить доступность, попробуйте снова",
        "IMPERSONATING_ERROR": "Невозможно изменить доступность выдавая себя за пользователя"
      },
      "EMAIL": {
        "LABEL": "Ваш адрес электронной почты",
        "ERROR": "Пожалуйста, введите действительный адрес электронной почты",
        "PLACEHOLDER": "Введите email, который будет отображаться в диалогах"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Текущий пароль",
        "ERROR": "Пожалуйста, введите текущий пароль",
        "PLACEHOLDER": "Пожалуйста, введите текущий пароль"
      },
      "PASSWORD": {
        "LABEL": "Новый пароль",
        "ERROR": "Введите пароль из 6 или более символов",
        "PLACEHOLDER": "Пожалуйста, введите новый пароль"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Подтвердите новый пароль",
        "ERROR": "Подтверждение пароля должно соответствовать паролю",
        "PLACEHOLDER": "Пожалуйста, введите новый пароль еще раз"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Изменить",
    "CHANGE_ACCOUNTS": "Сменить аккаунт",
    "SWITCH_ACCOUNT": "Сменить аккаунт",
    "CONTACT_SUPPORT": "Связаться с поддержкой",
    "SELECTOR_SUBTITLE": "Выберите аккаунт из списка",
    "PROFILE_SETTINGS": "Настройки профиля",
    "YEAR_IN_REVIEW": "Year in Review",
    "KEYBOARD_SHORTCUTS": "Горячие клавиши",
    "APPEARANCE": "Изменить внешний вид",
    "SUPER_ADMIN_CONSOLE": "Консоль супер администратора",
    "DOCS": "Открыть документацию",
    "CHANGELOG": "Журнал изменений",
    "LOGOUT": "Выйти из системы"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "дней до окончания бесплатного периода.",
    "TRAIL_BUTTON": "Купить",
    "DELETED_USER": "Удаленный пользователь",
    "EMAIL_VERIFICATION_PENDING": "Похоже, что вы еще не подтвердили свой адрес электронной почты. Пожалуйста, проверьте свой почтовый ящик для подтверждения электронной почты.",
    "RESEND_VERIFICATION_MAIL": "Повторно отправить письмо с подтверждением",
    "EMAIL_VERIFICATION_SENT": "Письмо с подтверждением отправлено. Пожалуйста, проверьте свой почтовый ящик.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Аккаунт заблокирован",
      "MESSAGE": "Ваша учетная запись приостановлена. Пожалуйста, обратитесь в службу поддержки для получения дополнительной информации."
    },
    "NO_ACCOUNTS": {
      "TITLE": "No account found",
      "MESSAGE_CLOUD": "You are not part of any accounts right now. If you think this is a mistake, please reach out to our support team.",
      "MESSAGE_SELF_HOSTED": "You are not part of any accounts right now. Please reach out to your administrator.",
      "LOGOUT": "Выйти из системы"
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Копировать",
      "CODEPEN": "Открыть в CodePen",
      "COPY_SUCCESSFUL": "Код скопирован в буфер обмена"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Показать больше",
      "SHOW_LESS": "Показать меньше"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Скачать",
      "UPLOADING": "Загружаем...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Эта история больше недоступна.",
      "INSTAGRAM_STORY_REPLY": "Ответил на вашу историю:"
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Просмотреть на карте"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Отправить"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "Это изображение больше недоступно.",
      "LOADING_FAILED": "Не удалось загрузить"
    }
  },
  "CONFIRM_EMAIL": "Проверка...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Добавить источник"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "Нет элементов",
    "CURRENTLY_VIEWING_ACCOUNT": "Сейчас просматривается:",
    "SWITCH": "Переключить",
    "INBOX_VIEW": "Просмотр входящих сообщений",
    "CONVERSATIONS": "Диалоги",
    "INBOX": "Мои Входящие",
    "ALL_CONVERSATIONS": "Диалоги",
    "MENTIONED_CONVERSATIONS": "Упоминания",
    "PARTICIPATING_CONVERSATIONS": "Участвующие",
    "UNATTENDED_CONVERSATIONS": "Неотвеченные",
    "REPORTS": "Отчёты",
    "SETTINGS": "Настройки",
    "CONTACTS": "Контакты",
    "ACTIVE": "Активные",
    "COMPANIES": "Компании",
    "ALL_COMPANIES": "Все компании",
    "CAPTAIN": "Капитан",
    "CAPTAIN_ASSISTANTS": "Ассистенты",
    "CAPTAIN_OVERVIEW": "Обзор",
    "CAPTAIN_DOCUMENTS": "Документы",
    "CAPTAIN_RESPONSES": "FAQ",
    "CAPTAIN_TOOLS": "Инструменты",
    "CAPTAIN_SCENARIOS": "Сценарии",
    "CAPTAIN_PLAYGROUND": "Площадка",
    "CAPTAIN_INBOXES": "Источники",
    "CAPTAIN_SETTINGS": "Настройки",
    "HOME": "Главная",
    "AGENTS": "Операторы",
    "AGENT_BOTS": "Боты",
    "AUDIT_LOGS": "Журнал аудита",
    "INBOXES": "Источники",
    "NOTIFICATIONS": "Уведомления",
    "CANNED_RESPONSES": "Шаблонные ответы",
    "INTEGRATIONS": "Интеграции",
    "DATA": "Data",
    "PROFILE_SETTINGS": "Настройки профиля",
    "ACCOUNT_SETTINGS": "Настройки аккаунта",
    "APPLICATIONS": "Приложения",
    "LABELS": "Категории",
    "CUSTOM_ATTRIBUTES": "Пользовательские атрибуты",
    "AUTOMATION": "Автоматизация",
    "MACROS": "Макрос",
    "TEAMS": "Команды",
    "BILLING": "Платёж",
    "CUSTOM_VIEWS_FOLDER": "Папки",
    "CUSTOM_VIEWS_SEGMENTS": "Сегменты",
    "ALL_CONTACTS": "Все контакты",
    "TAGGED_WITH": "С метками",
    "NEW_LABEL": "Новая метка",
    "NEW_TEAM": "Новая команда",
    "NEW_INBOX": "Новые канал",
    "REPORTS_CONVERSATION": "Диалоги",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Онлайн чат",
    "SMS": "SMS",
    "WHATSAPP": "WhatsApp",
    "CAMPAIGNS": "Кампании",
    "ONGOING": "Повторяющиеся",
    "ONE_OFF": "Единоразовые",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Бот",
    "REPORTS_AGENT": "Операторы",
    "REPORTS_LABEL": "Категории",
    "REPORTS_INBOX": "Электронная почта",
    "REPORTS_TEAM": "Команда",
    "AGENT_ASSIGNMENT": "Назначение агента",
    "SET_AVAILABILITY_TITLE": "Установить себя",
    "SET_YOUR_AVAILABILITY": "Настройте ваши рабочие часы",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Пользовательские роли",
    "BETA": "Бета",
    "REPORTS_OVERVIEW": "Обзор",
    "REAUTHORIZE": "Срок действия вашего источника истек, пожалуйста, переподключите\n чтобы снова получать и отправлять сообщения",
    "HELP_CENTER": {
      "TITLE": "Центр поддержки",
      "ARTICLES": "Статьи",
      "CATEGORIES": "Категории",
      "LOCALES": "Locales",
      "SETTINGS": "Настройки"
    },
    "CHANNELS": "Источники",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Отметить автоматически",
      "INFO_TEXT": "Позволить системе автоматически отмечать вас в автономном режиме, если вы не используете приложение или приборную панель.",
      "INFO_SHORT": "Автоматически отмечать оффлайн, когда вы не используете приложение."
    },
    "SORT_TOOLTIP": "Сортировка",
    "SORT_BY": "Сортировать по",
    "SORT_GROUPS": {
      "CREATED": "Sort by date of creation",
      "ALPHABETICAL": "Sort in alphabetical order",
      "UNREAD_COUNT": "Sort by unread count"
    },
    "SORT_OPTIONS": {
      "CREATED_DESC": "Newest first",
      "CREATED_ASC": "Oldest first",
      "ALPHABETICAL_ASC": "Ascending (A - Z)",
      "ALPHABETICAL_DESC": "Descending (Z - A)",
      "UNREAD_COUNT_DESC": "Highest first",
      "UNREAD_COUNT_ASC": "Lowest first"
    },
    "DOCS": "Открыть документацию",
    "SECURITY": "Безопасность",
    "CAPTAIN_AI": "Капитан",
    "CONVERSATION_WORKFLOW": "Conversation Workflow"
  },
  "DATA_IMPORTS": {
    "HEADER": "Data",
    "DESCRIPTION": "Bring your existing contacts and past conversations into this account from another support tool. Each import runs in the background, so you can keep working while it finishes, track its progress, and review anything that was skipped along the way.",
    "LOADING": "Fetching imports",
    "DEFAULT_IMPORT_NAME": "Intercom import",
    "TABS": {
      "IMPORT": "Импортировать",
      "EXPORT": "Экспорт"
    },
    "TYPES": {
      "CONTACTS": "Контакты",
      "CONVERSATIONS": "Диалоги",
      "MESSAGES": "Сообщения"
    },
    "DRAWER": {
      "TITLE": "New import",
      "SOURCE": "Source",
      "NAME": "Import name",
      "NAME_PLACEHOLDER": "July Intercom migration",
      "ACCESS_KEY": "Intercom access key",
      "ACCESS_KEY_PLACEHOLDER": "Paste your Intercom access key",
      "DATA_TYPES": "Data to import",
      "VALIDATING": "Validating access key...",
      "VALID_KEY": "Access key validated.",
      "INVALID_KEY": "Could not validate this access key.",
      "ACTIVE_IMPORT": "Wait for the active import to finish before starting another one.",
      "CANCEL": "Отменить",
      "IMPORT": "Импортировать"
    },
    "EXPORT": {
      "TITLE": "Exports are on the way",
      "DESCRIPTION": "Export your contacts and conversations out of this account. This workflow is coming soon.",
      "COMING_SOON": "Coming soon"
    },
    "TABLE": {
      "TITLE": "Recent imports",
      "EMPTY": "No imports yet",
      "EMPTY_DESCRIPTION": "Start an import to bring your existing customer history into this account.",
      "NEW_IMPORT": "Импортировать",
      "COUNT": "{count} imports",
      "UNNAMED": "Untitled import",
      "IMPORTED_COUNT": "{count} imported",
      "VIEW": "View import",
      "NAME": "Имя",
      "TYPE": "Тип",
      "STATUS": "Статус",
      "IMPORTED": "Imported",
      "CREATED": "Создан",
      "ABANDON": "Abandon"
    },
    "DETAIL": {
      "BACK": "Back to imports",
      "ERRORS": "Errors",
      "SKIP_LOGS": "Skip logs",
      "SOURCE": "Source",
      "IMPORT_TYPES": "Import types",
      "CREATED": "Создан",
      "DURATION": "Продолжительность",
      "INITIATED_BY": "Started by",
      "PROGRESS": "Import progress",
      "PROGRESS_WITH_TOTAL": "{imported} of {total} imported",
      "PROGRESS_WITHOUT_TOTAL": "{imported} imported",
      "PROGRESS_OF_TOTAL": "of {total} imported",
      "PROGRESS_IMPORTED": "imported",
      "LAST_UPDATED_TOOLTIP": "Последнее обновление {time}",
      "NO_SKIP_LOGS": "No skipped or failed records recorded.",
      "DOWNLOAD_SKIP_LOGS": "Download CSV",
      "DOWNLOAD_ERROR_LOGS": "Download CSV",
      "ALL_SKIP_LOGS": "Все",
      "KIND": "Kind",
      "NO_ERRORS": "No errors recorded.",
      "ERROR_CODE": "Code",
      "SOURCE_OBJECT": "Source object",
      "MESSAGE": "Сообщение"
    },
    "MONITOR": {
      "LIVE": "Live updates every {seconds}s",
      "LAST_UPDATED": "Последнее обновление {time}",
      "REFRESH": "Обновить",
      "REFRESHING": "Refreshing",
      "STAGES": {
        "unknown": "Waiting for update",
        "queued": "Queued",
        "contacts": "Importing contacts",
        "conversations": "Importing conversations",
        "finalizing": "Finalizing import",
        "completed": "Выполнено",
        "completed_with_errors": "Completed with errors",
        "failed": "Не удалось",
        "abandoned": "Abandoned"
      }
    },
    "ALERTS": {
      "IMPORT_STARTED": "Intercom import has started.",
      "IMPORT_ABANDONED": "Intercom import has been abandoned.",
      "IMPORT_FAILED": "Could not start the Intercom import."
    }
  },
  "CAPTAIN_SETTINGS": {
    "TITLE": "Captain Settings",
    "DESCRIPTION": "Configure your AI models and features for Captain. Captain follows a credit based billing, you will be charged credits for every action Captain takes based on the model selected.",
    "LOADING": "Loading Captain configuration...",
    "LINK_TEXT": "Learn more about Captain Credits",
    "NOT_ENABLED": "Captain is not enabled for your account. Please upgrade your plan to access Captain features.",
    "MODEL_CONFIG": {
      "TITLE": "Model Configuration",
      "DESCRIPTION": "Select AI models for different features.",
      "SELECT_MODEL": "Select model",
      "CREDITS_PER_MESSAGE": "{credits} credit/message",
      "COMING_SOON": "Coming soon",
      "EDITOR": {
        "TITLE": "Editor Features",
        "DESCRIPTION": "Powers smart compose, grammar corrections, tone adjustments, and content enhancement in your message editor."
      },
      "ASSISTANT": {
        "TITLE": "Ассистент",
        "DESCRIPTION": "Handles automated responses, conversation summaries, and intelligent reply suggestions for customer interactions."
      },
      "COPILOT": {
        "TITLE": "Co-pilot",
        "DESCRIPTION": "Provides real-time contextual suggestions, knowledge base recommendations, and proactive insights during conversations."
      }
    },
    "FEATURES": {
      "TITLE": "Возможности",
      "DESCRIPTION": "Enable or disable AI-powered features.",
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Audio Transcription",
        "DESCRIPTION": "Automatically convert voice messages and call recordings into searchable text transcripts.",
        "MODEL_TITLE": "Audio Transcription Model",
        "MODEL_DESCRIPTION": "Select the AI model to use for converting audio messages into text transcripts"
      },
      "HELP_CENTER_SEARCH": {
        "TITLE": "Help Center Search Indexing",
        "DESCRIPTION": "Use AI for context aware search inside your help center articles."
      },
      "LABEL_SUGGESTION": {
        "TITLE": "Label Suggestion",
        "DESCRIPTION": "Automatically suggest relevant labels and tags for conversations based on content analysis and context.",
        "MODEL_TITLE": "Label Suggestion Model",
        "MODEL_DESCRIPTION": "Select the AI model to use for analyzing conversations and suggesting appropriate labels"
      }
    },
    "API": {
      "SUCCESS": "Captain settings updated successfully.",
      "ERROR": "Failed to update Captain settings. Please try again."
    }
  },
  "BILLING_SETTINGS": {
    "TITLE": "Платёж",
    "DESCRIPTION": "Управляйте подпиской здесь, обновите тарифный план и получите больше возможностей для вашей команды.",
    "CURRENT_PLAN": {
      "TITLE": "Текущий план",
      "PLAN_NOTE": "На данный момент вы подписаны на ** план{plan}** с **{quantity}** лицензиями",
      "SEAT_COUNT": "Количество мест",
      "RENEWS_ON": "Продление",
      "CURRENCY": "Currency"
    },
    "CURRENCY": {
      "SELECT": {
        "TITLE": "Choose your billing currency",
        "DESCRIPTION": "Select the currency you'd like to be billed in. This can't be changed once your subscription is created."
      },
      "OPTIONS": {
        "USD": "US Dollar (USD)",
        "BRL": "Brazilian Real (BRL)"
      }
    },
    "VIEW_PRICING": "Посмотреть цены",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Управление подпиской",
      "DESCRIPTION": "Просматривайте ваши предыдущие счета, редактируйте платежные реквизиты или отмените подписку.",
      "BUTTON_TXT": "Перейти на платёжный портал"
    },
    "CAPTAIN": {
      "TITLE": "Капитан",
      "DESCRIPTION": "Управляйте использованием и кредитами для Captain AI.",
      "BUTTON_TXT": "Купить дополнительные кредиты",
      "DOCUMENTS": "Документы",
      "RESPONSES": "Ответы",
      "UPGRADE": "Captain недоступен в бесплатном тарифном плане, обновите его, чтобы получить доступ к ассистентам, copilot и другим функциям.",
      "REFRESH_CREDITS": "Обновить"
    },
    "CHAT_WITH_US": {
      "TITLE": "Нужна помощь?",
      "DESCRIPTION": "Вы сталкиваетесь с какими-либо проблемами при оплате? Мы здесь, чтобы помочь.",
      "BUTTON_TXT": "Пообщайтесь с нами"
    },
    "NO_BILLING_USER": "Ваш платёжный счёт настраивается. Пожалуйста, обновите страницу и повторите попытку.",
    "TOPUP": {
      "BUY_CREDITS": "Купить дополнительные кредиты",
      "MODAL_TITLE": "Купить ИИ кредиты",
      "MODAL_DESCRIPTION": "Купить дополнительные кредиты для Captain AI.",
      "CREDITS": "КРЕДИТЫ",
      "ONE_TIME": "один раз",
      "POPULAR": "Самый популярный",
      "NOTE_TITLE": "Примечание:",
      "NOTE_DESCRIPTION": "Credits are added immediately and expire in 6 months. An active subscription is required to use credits. Purchased credits are consumed after your monthly plan credits.",
      "CANCEL": "Отменить",
      "PURCHASE": "Купить кредиты",
      "LOADING": "Загрузка настроек...",
      "FETCH_ERROR": "Не удалось загрузить настройки оплаты. Попробуйте ещё раз.",
      "RETRY": "Повторить",
      "PURCHASE_ERROR": "Не удалось провести оплату. Попробуйте ещё раз.",
      "PURCHASE_SUCCESS": "Successfully added {credits} credits to your account",
      "CONFIRM": {
        "TITLE": "Confirm Purchase",
        "DESCRIPTION": "You are about to purchase {credits} credits for {amount}.",
        "INSTANT_DEDUCTION_NOTE": "Your saved card will be charged immediately upon confirmation.",
        "GO_BACK": "Вернуться",
        "CONFIRM_PURCHASE": "Confirm Purchase"
      }
    }
  },
  "SECURITY_SETTINGS": {
    "TITLE": "Безопасность",
    "DESCRIPTION": "Управление настройками безопасности вашего аккаунта.",
    "LINK_TEXT": "Узнать больше о SAML SSO",
    "SAML_DISABLED_MESSAGE": "SAML SSO is currently disabled. Please contact your administrator to enable this feature.",
    "SAML": {
      "TITLE": "SAML SSO",
      "NOTE": "Настройка единого SAML входа для вашей учетной записи. Пользователи будут аутентифицироваться через вашего провайдера идентификации вместо использования электронной почты/пароля.",
      "ACS_URL": {
        "LABEL": "ACS URL",
        "TOOLTIP": "Assertion Consumer Service URL - Настройте этот URL в IdP в качестве назначения для SAML ответов"
      },
      "SSO_URL": {
        "LABEL": "SSO URL",
        "HELP": "URL, куда будут отправляться запросы аутентификации SAML",
        "PLACEHOLDER": "https://your-idp.com/saml/sso"
      },
      "CERTIFICATE": {
        "LABEL": "Подписанный сертификат в формате PEM",
        "HELP": "Публичный сертификат от вашего поставщика сертификатов используемый для проверки SAML ответов",
        "PLACEHOLDER": "-----BEGIN CERTIFICATE-----\nMIIC..."
      },
      "FINGERPRINT": {
        "LABEL": "Отпечаток",
        "TOOLTIP": "Отпечаток SHA-1 сертификата. Используется для проверки сертификата в конфигурации IdP"
      },
      "COPY_SUCCESS": "Код скопирован в буфер обмена",
      "SP_ENTITY_ID": {
        "LABEL": "ID сущности SP",
        "HELP": "Уникальный идентификатор для этого приложения как поставщика услуг (автосгенерированный).",
        "TOOLTIP": "Уникальный идентификатор для Chatwoot как поставщик услуг - Настройте это в настройках IdP"
      },
      "IDP_ENTITY_ID": {
        "LABEL": "ID сущности провайдера идентификации",
        "HELP": "Уникальный идентификатор для вашего поставщика идентификации (обычно находится в конфигурации IdP)",
        "PLACEHOLDER": "https://your-idp.com/saml"
      },
      "UPDATE_BUTTON": "Обновить настройки SAML",
      "API": {
        "SUCCESS": "Настройки SAML успешно обновлены",
        "ERROR": "Не удалось обновить настройки SAML",
        "ERROR_LOADING": "Не удалось загрузить настройки SAML",
        "DISABLED": "SAML настройки успешно отключены"
      },
      "VALIDATION": {
        "REQUIRED_FIELDS": "SSO URL, идентификатор сущности провайдера и сертификат являются обязательными полями",
        "SSO_URL_ERROR": "Пожалуйста, введите правильный SSO URL",
        "CERTIFICATE_ERROR": "Сертификат обязателен",
        "IDP_ENTITY_ID_ERROR": "ID сущности поставщика идентификации обязателен"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "Функция SAML SSO доступна только в Enterprise plan.",
        "UPGRADE_PROMPT": "Обновитесь до Enterprise plan, чтобы получить доступ к единому входу SAML и другим продвинутым функциям безопасности.",
        "ASK_ADMIN": "Пожалуйста, обратитесь к вашему администратору для обновления."
      },
      "PAYWALL": {
        "TITLE": "Обновитесь, чтобы включить SAML SSO",
        "AVAILABLE_ON": "Функция SAML SSO доступна только в Enterprise plan.",
        "UPGRADE_PROMPT": "Обновите свой тарифный план, чтобы получить доступ к единому входу SAML и другим расширенным функциям.",
        "UPGRADE_NOW": "Обновить сейчас",
        "CANCEL_ANYTIME": "Вы можете изменить или отменить ваш тарифный план в любое время"
      },
      "ATTRIBUTE_MAPPING": {
        "TITLE": "Настройки SAML Атрибута",
        "DESCRIPTION": "Следующие сопоставления атрибутов должны быть настроены в вашем поставщике идентификации"
      },
      "INFO_SECTION": {
        "TITLE": "Информация о поставщике услуг SAML",
        "TOOLTIP": "Скопируйте эти значения и настройте их в вашем поставщике идентификации для установления соединения SAML"
      }
    }
  },
  "CONVERSATION_WORKFLOW": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Conversation Workflows",
        "DESCRIPTION": "Configure rules and required fields for conversation resolution."
      }
    },
    "REQUIRED_ATTRIBUTES": {
      "TITLE": "Attributes required on resolution",
      "DESCRIPTION": "When resolving a conversation, agents will be prompted to fill these attributes if they haven't yet.",
      "NO_ATTRIBUTES": "No attributes added yet",
      "ADD": {
        "TITLE": "Add Attributes",
        "SEARCH_PLACEHOLDER": "Поиск по атрибутам"
      },
      "SAVE": {
        "SUCCESS": "Required attributes updated",
        "ERROR": "Could not update required attributes, please try again"
      },
      "MODAL": {
        "TITLE": "Решить разговор",
        "DESCRIPTION": "Please fill in the following custom attributes before resolving this conversation",
        "ACTIONS": {
          "RESOLVE": "Решить разговор",
          "CANCEL": "Отменить"
        },
        "PLACEHOLDERS": {
          "TEXT": "Write a note...",
          "NUMBER": "Enter a number",
          "LINK": "Add a link",
          "DATE": "Pick a date",
          "LIST": "Выберите параметр"
        },
        "CHECKBOX": {
          "YES": "Да",
          "NO": "Нет"
        }
      },
      "PAYWALL": {
        "TITLE": "Upgrade to use required attributes",
        "AVAILABLE_ON": "The required conversation attributes feature is available on the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade your plan to prompt agents to fill required attributes before conversation resolution.",
        "UPGRADE_NOW": "Обновить сейчас",
        "CANCEL_ANYTIME": "Вы можете изменить или отменить ваш тарифный план в любое время"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The required conversation attributes feature is available on the paid plans.",
        "UPGRADE_PROMPT": "Upgrade to a paid plan to enforce required attributes before conversation resolution.",
        "ASK_ADMIN": "Пожалуйста, обратитесь к вашему администратору для обновления."
      }
    }
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Ой! Мы не смогли найти ни одного аккаунта в Chatwoot. Пожалуйста, создайте новый аккаунт, чтобы продолжить.",
    "NEW_ACCOUNT": "Новый аккаунт",
    "SELECTOR_SUBTITLE": "Создать новый аккаунт",
    "API": {
      "SUCCESS_MESSAGE": "Аккаунт создан",
      "EXIST_MESSAGE": "Аккаунт уже существует",
      "ERROR_MESSAGE": "Не удается соединиться с сервером Woot, попробуйте позже"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Название компании",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Отправить",
      "CANCEL": "Отменить"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Показать все ярлыки",
    "TITLE": {
      "OPEN_CONVERSATION": "Открыть беседу",
      "RESOLVE_AND_NEXT": "Решить и перейти к следующему",
      "NAVIGATE_DROPDOWN": "Навигация в выпадающем списке",
      "RESOLVE_CONVERSATION": "Решить диалог",
      "GO_TO_CONVERSATION_DASHBOARD": "Перейти к панели диалогов",
      "ADD_ATTACHMENT": "Добавить вложение",
      "GO_TO_CONTACTS_DASHBOARD": "Перейти к панели контактов",
      "TOGGLE_SIDEBAR": "Переключить боковую панель",
      "GO_TO_REPORTS_SIDEBAR": "Перейти к боковой панели отчетов",
      "MOVE_TO_NEXT_TAB": "Переместить на следующую вкладку в списке диалогов",
      "GO_TO_SETTINGS": "Перейти к настройкам",
      "SWITCH_TO_PRIVATE_NOTE": "Переключиться на заметку",
      "SWITCH_TO_REPLY": "Переключиться на ответ",
      "TOGGLE_SNOOZE_DROPDOWN": "Вкл/выкл повтор"
    }
  },
  "ASSIGNMENT_POLICY": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Назначение агента",
        "DESCRIPTION": "Определите политики для эффективного управления нагрузкой и маршрутами диалогов в зависимости от потребностей входящих сообщений и агентов. Узнайте больше здесь"
      },
      "ASSIGNMENT_POLICY": {
        "TITLE": "Назначение политики",
        "DESCRIPTION": "Управление тем, как диалоги назначаются во входящих.",
        "FEATURES": [
          "Назначать диалоги равномерно или по доступному объему",
          "Добавить правила справедливого распределения во избежание перегрузки любого агента",
          "Добавить ящики в политику - по одной политике на ящик"
        ]
      },
      "AGENT_CAPACITY_POLICY": {
        "TITLE": "Политика нагрузки агента",
        "DESCRIPTION": "Управление загрузкой агентов.",
        "FEATURES": [
          "Определить максимальное количество диалогов во входящих",
          "Создавать исключения, основанные на метках и времени",
          "Добавить агента в политику - по одной политике на агента"
        ]
      }
    },
    "AGENT_ASSIGNMENT_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Назначение политики",
          "CREATE_POLICY": "Новая политика"
        },
        "CARD": {
          "ORDER": "Соритировка",
          "PRIORITY": "Приоритет",
          "ACTIVE": "Активно",
          "INACTIVE": "Неактивен",
          "POPOVER": "Добавленные ящики",
          "EDIT": "Редактировать"
        },
        "NO_RECORDS_FOUND": "Не найдены связанные политики"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Создать связанную политику"
        },
        "CREATE_BUTTON": "Создать политику",
        "API": {
          "SUCCESS_MESSAGE": "Связанная политика успешно создана",
          "ERROR_MESSAGE": "Не удалось создать связанную политику",
          "INBOX_LINKED": "Inbox has been linked to the policy"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Изменение связанной политики"
        },
        "EDIT_BUTTON": "Изменить политику",
        "CONFIRM_ADD_INBOX_DIALOG": {
          "TITLE": "Добавить почту",
          "DESCRIPTION": "{inboxName} ящик уже связан с другой политикой. Вы уверены, что хотите связать его с этой политикой? Он будет удален из другой политики.",
          "CONFIRM_BUTTON_LABEL": "Продолжить",
          "CANCEL_BUTTON_LABEL": "Отменить"
        },
        "INBOX_LINK_PROMPT": {
          "TITLE": "Link inbox to policy",
          "DESCRIPTION": "Would you like to link this inbox to the assignment policy?",
          "LINK_BUTTON": "Link inbox",
          "CANCEL_BUTTON": "Skip"
        },
        "API": {
          "SUCCESS_MESSAGE": "Связанная политика успешно обновлена",
          "ERROR_MESSAGE": "Не удалось обновить связанную политику"
        },
        "INBOX_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Почтовый ящик добавлен в политику",
            "ERROR_MESSAGE": "Не удалось добавить почтовый ящик в политику"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Почтовый ящик удалён из политики",
            "ERROR_MESSAGE": "Не удалось удалить почтовый ящик из политики"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Название политики:",
          "PLACEHOLDER": "Введите название политики"
        },
        "DESCRIPTION": {
          "LABEL": "Описание:",
          "PLACEHOLDER": "Введите описание"
        },
        "STATUS": {
          "LABEL": "Статус:",
          "PLACEHOLDER": "Выбрать статус",
          "ACTIVE": "Политика активна",
          "INACTIVE": "Политика неактивна"
        },
        "ASSIGNMENT_ORDER": {
          "LABEL": "Порядок назначения",
          "ROUND_ROBIN": {
            "LABEL": "Round robin",
            "DESCRIPTION": "Назначить разговоры равномерно между агентами."
          },
          "BALANCED": {
            "LABEL": "Сбалансированный",
            "DESCRIPTION": "Назначить диалоги на основе доступной пропускной способности.",
            "PREMIUM_MESSAGE": "Upgrade to access balanced assignment and agent capacity management.",
            "PREMIUM_BADGE": "Premium"
          }
        },
        "ASSIGNMENT_PRIORITY": {
          "LABEL": "Приоритет назначения",
          "EARLIEST_CREATED": {
            "LABEL": "Раннее созданное",
            "DESCRIPTION": "Созданный диалог назначается в первую очередь."
          },
          "LONGEST_WAITING": {
            "LABEL": "Длительное ожидание",
            "DESCRIPTION": "Сначала назначается диалог, ожидающий назначения дольше всех."
          }
        },
        "FAIR_DISTRIBUTION": {
          "LABEL": "Политика справедливого распределения",
          "DESCRIPTION": "Установите максимальное количество писем, которые могут быть назначены каждому агенту в пределах окна времени, чтобы избежать перезагрузки любого одного агента. Это требуемое поле по умолчанию используется для 100 диалогов в час.",
          "INPUT_MAX": "Назначить макс.",
          "DURATION": "Диалоги на каждого агента в каждом"
        },
        "EXCLUDE_OLDER_THAN": {
          "LABEL": "Skip stale conversations",
          "DESCRIPTION": "Skip unassigned conversations older than this. Defaults to 7 days; clear to disable."
        },
        "INBOXES": {
          "LABEL": "Добавленные ящики",
          "DESCRIPTION": "Добавьте почтовые ящики, для которых будет применяться эта политика.",
          "ADD_BUTTON": "Добавить почту",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Поиск и выбор почтовых ящиков для добавления",
            "ADD_BUTTON": "Добавить"
          },
          "EMPTY_STATE": "Нет почтовых ящиков в этой политике, добавьте ящики для начала",
          "API": {
            "SUCCESS_MESSAGE": "Почтовый ящик успешно добавлен в политику",
            "ERROR_MESSAGE": "Не удалось добавить почтовый ящик в политику"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Связанная политика успешно удалена",
        "ERROR_MESSAGE": "Не удалось удалить связанную политику"
      }
    },
    "AGENT_CAPACITY_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Пропускная способность сотрудника",
          "CREATE_POLICY": "Новая политика"
        },
        "CARD": {
          "POPOVER": "Добавленные агенты",
          "EDIT": "Редактировать"
        },
        "NO_RECORDS_FOUND": "Политики пропускной способности агентов не найдены"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Создать политики нагрузки агента"
        },
        "CREATE_BUTTON": "Создать политику",
        "API": {
          "SUCCESS_MESSAGE": "Политика нагрузки сотрудника успешно создана",
          "ERROR_MESSAGE": "Не удалось создать политику нагрузки агента"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Изменить политики нагрузки агента"
        },
        "EDIT_BUTTON": "Изменить политику",
        "CONFIRM_ADD_AGENT_DIALOG": {
          "TITLE": "Добавить оператора",
          "DESCRIPTION": "{agentName} уже связан с другой политикой. Вы уверены, что хотите связать его с этой политикой? Он будет удален из другой политики.",
          "CONFIRM_BUTTON_LABEL": "Продолжить",
          "CANCEL_BUTTON_LABEL": "Отменить"
        },
        "API": {
          "SUCCESS_MESSAGE": "Политика нагрузки сотрудника успешно обновлена",
          "ERROR_MESSAGE": "Не удалось обновить политику нагрузки агента"
        },
        "AGENT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Оператор успешно добавлен в политику",
            "ERROR_MESSAGE": "Не удалось добавить агента в политику"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Агент успешно удален из политики",
            "ERROR_MESSAGE": "Не удалось удалить агента из политики"
          }
        },
        "INBOX_LIMIT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Inbox limit added successfully",
            "ERROR_MESSAGE": "Failed to add inbox limit"
          },
          "UPDATE": {
            "SUCCESS_MESSAGE": "Inbox limit updated successfully",
            "ERROR_MESSAGE": "Failed to update inbox limit"
          },
          "DELETE": {
            "SUCCESS_MESSAGE": "Inbox limit deleted successfully",
            "ERROR_MESSAGE": "Failed to delete inbox limit"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Название политики:",
          "PLACEHOLDER": "Введите название политики"
        },
        "DESCRIPTION": {
          "LABEL": "Описание:",
          "PLACEHOLDER": "Введите описание"
        },
        "INBOX_CAPACITY_LIMIT": {
          "LABEL": "Ограничение лимитов ящика",
          "ADD_BUTTON": "Добавить почтовый ящик",
          "FIELD": {
            "SELECT_INBOX": "Выбрать почтовый ящик",
            "MAX_CONVERSATIONS": "Максимум диалогов",
            "SET_LIMIT": "Установить лимит"
          },
          "EMPTY_STATE": "Не установлен лимит почтового ящика"
        },
        "EXCLUSION_RULES": {
          "LABEL": "Правила исключения",
          "DESCRIPTION": "Диалоги, которые удовлетворяют следующим условиям, не будут учитываться в качестве агентских возможностей",
          "TAGS": {
            "LABEL": "Исключить диалоги со специальными метками",
            "ADD_TAG": "добавить тег",
            "DROPDOWN": {
              "SEARCH_PLACEHOLDER": "Поиск и выбор тегов для добавления"
            },
            "EMPTY_STATE": "Нет добавленных тегов в этой политике."
          },
          "DURATION": {
            "LABEL": "Исключить диалоги старше указанного срока",
            "PLACEHOLDER": "Установить время"
          }
        },
        "USERS": {
          "LABEL": "Назначенные агенты",
          "DESCRIPTION": "Добавьте агентов, для которых будет применяться эта политика.",
          "ADD_BUTTON": "Добавить агента",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Поиск и выбор агентов для добавления",
            "ADD_BUTTON": "Добавить"
          },
          "EMPTY_STATE": "Агенты не добавлены",
          "API": {
            "SUCCESS_MESSAGE": "Агент успешно добавлен в политику",
            "ERROR_MESSAGE": "Не удалось добавить агента в политику"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Политика нагрузки сотрудника успешно удалена",
        "ERROR_MESSAGE": "Не удалось удалить политику нагрузки агента"
      }
    },
    "DELETE_POLICY": {
      "TITLE": "Удалить политику",
      "DESCRIPTION": "Вы уверены, что хотите удалить эту политику? Это действие не может быть отменено.",
      "CONFIRM_BUTTON_LABEL": "Удалить",
      "CANCEL_BUTTON_LABEL": "Отменить"
    }
  }
}
